<div class="ag-paging-panel ag-unselectable">
  <span class="ag-paging-row-summary-panel" role="status">
    <span
      ><ng-container i18n="@@PaginationStatusBarOrdersPerPage"
        >Orders per page:
      </ng-container>
      <mat-select
        placeholder="50"
        panelClass="pagination-option-list"
        (selectionChange)="changePageSize($event)"
      >
        @for (value of [25, 50, 100, 200, 300, 400, 500]; track value) {
        <mat-option class="mat-option-selected" [value]="value">{{
          value
        }}</mat-option>
        }
      </mat-select>
    </span>
  </span>

  @if (hasRowsToShow()) {
  <span class="ag-paging-row-summary-panel panel-hit-count" role="status">
    <span ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number">
      {{ pageRowStartIndex }}
    </span>
    <span i18n="@@PaginationStatusBarTo">to</span>
    <span ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number">
      {{ pageRowEndIndex }}
    </span>
    <span i18n="@@PaginationStatusBarOf">of</span>
    <span ref="lbRecordCount" class="ag-paging-row-summary-panel-number">
      {{ totalNumberOfRows }}
    </span>
  </span>
  }
  <span class="ag-paging-page-summary-panel" role="presentation">
    <button
      mat-icon-button
      ref="btFirst"
      class="ag-paging-button"
      aria-label="First Page"
      aria-disabled="true"
      (click)="onButtonClickFirst()"
      [ngClass]="{ 'ag-disabled': currentPage === 1 }"
    >
      <mat-icon> first_page </mat-icon>
    </button>

    <button
      mat-icon-button
      ref="btPrevious"
      class="ag-paging-button"
      aria-label="Previous Page"
      aria-disabled="true"
      (click)="onButtonClickPrevious()"
      [ngClass]="{ 'ag-disabled': currentPage === 1 }"
    >
      <mat-icon> keyboard_arrow_left </mat-icon>
    </button>

    <span class="ag-paging-description" role="status">
      <span i18n="@@PaginationStatusBarPage">Page</span>
      <span ref="lbCurrent" class="ag-paging-number">
        {{ currentPage }}
      </span>
      <span i18n="@@PaginationStatusBarOf">of</span>
      <span ref="lbTotal" class="ag-paging-number">
        {{ getTotalPageSize() }}
      </span>
    </span>

    <button
      mat-icon-button
      ref="btNext"
      class="ag-paging-button"
      aria-label="Next Page"
      aria-disabled="false"
      tabindex="0"
      (click)="onButtonClickNext()"
      [ngClass]="{ 'ag-disabled': currentPage === getTotalPageSize() }"
    >
      <mat-icon> keyboard_arrow_right </mat-icon>
    </button>

    <button
      mat-icon-button
      ref="btLast"
      class="ag-paging-button"
      aria-label="Last Page"
      aria-disabled="false"
      tabindex="0"
      (click)="onButtonClickLast()"
      [ngClass]="{ 'ag-disabled': currentPage === getTotalPageSize() }"
    >
      <mat-icon> last_page </mat-icon>
    </button>
  </span>
</div>
@if (totalNumberOfRows <= 0) {
<div class="no-results-available">No Results Available.</div>
}
